import React, { useEffect, useState } from "react";
import "./reviews.css";
import { FaStar, FaRegStar, FaStarHalfAlt } from "react-icons/fa";
import axiosInstance from "../../API/axiosInstance";

// Helper to render star icons based on a rating value
const renderStars = (value) => {
  const full = Math.floor(value);
  const half = value % 1 >= 0.25 && value % 1 < 0.75;
  const total = half ? full + 1 : full;

  return (
    <>
      {[...Array(full)].map((_, i) => <FaStar key={`full-${i}`} color="#ffa41c" />)}
      {half && <FaStarHalfAlt key="half" color="#ffa41c" />}
      {[...Array(5 - total)].map((_, i) => <FaRegStar key={`empty-${i}`} color="#ffa41c" />)}
    </>
  );
};

// Individual Review Card Component
const ReviewCard = ({ r }) => (
  <div className="review-card">
    <div className="review-header">
      <div className="avatar-circle">{r.username?.charAt(0).toUpperCase() || "U"}</div>
      <span>{r.username}</span>
    </div>

    <div className="review-rating-title">
      <div className="stars">{renderStars(r.rating)}</div>
      <strong className="review-title">{r.title}</strong>
    </div>

    <div className="review-meta">
      <span>Reviewed on {r.date || "October 28, 2023"}</span>
      {r.verified && <span className="verified-purchase">Verified Purchase</span>}
    </div>

    <p className="review-body">{r.content}</p>
  </div>
);

// Main Reviews Display Component
const ReviewsDisplay = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        /*
        // Your original API call
        const { data } = await axiosInstance.get("/reviews/website");
        setReviews(data || []);
        */
        const response = await axiosInstance.get('/reviews/website')

        if (response.status == 200) {
          setReviews(response.data)
        }

      } catch (err) {
        console.error("Failed to fetch reviews", err);
      }
    };
    fetchReviews();
  }, []);

  // Derived stats for summary block
  const totalReviews = reviews.length || 1;
  const avgRating = reviews.reduce((sum, r) => sum + r.rating, 0) / totalReviews;
  const ratingCounts = [5, 4, 3, 2, 1].map(
    (star) => reviews.filter((r) => Math.round(r.rating) === star).length
  );

  return (
    <div className="container reviews-container">
      <div className="row h-auto">
        {/* Left Column: Summary and Histogram */}
        <div className="col-lg-4 col-md-5">
          <div className="reviews-summary">
            <h3>Customer reviews</h3>
            <div className="summary-rating">
              <div className="stars">{renderStars(avgRating)}</div>
              <span>{avgRating.toFixed(1)} out of 5</span>
            </div>
            <p className="total-ratings">{reviews.length} global ratings</p>

            <div className="histogram">
              {[5, 4, 3, 2, 1].map((star, index) => {
                const count = ratingCounts[index];
                const percentage = totalReviews > 1 ? (count / (totalReviews - 1)) * 100 : 0;
                return (
                  <div key={star} className="histogram-row">
                    <span className="label">{star} star</span>
                    <div className="bar-track">
                      <div className="bar-fill" style={{ width: `${percentage}%` }} />
                    </div>
                    <span className="percentage">{Math.round(percentage)}%</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Right Column: Scrollable Review List */}
        <div className="col-lg-8 col-md-7 h-auto">
          <div className="reviews-list">
            {reviews.length > 0 ? (
              reviews.map((r) => <ReviewCard key={r.id} r={r} />)
            ) : (
              <p>No reviews yet.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewsDisplay;